function getItemOriginalPrice(item) {
  return (
    item.selectedVariation?.price ??
    item.price ??
    0
  );
}

function getItemFinalPrice(item) {
  return (
    item.selectedVariation?.finalPrice ??
    item.selectedVariation?.salePrice ??
    item.selectedVariation?.price ??
    item.finalPrice ??
    item.salePrice ??
    item.price ??
    0
  );
}

export function getTotalPrice(cart) {
  return cart.reduce((total, item) => {
    const price = getItemFinalPrice(item);

    return total + price * item.qty;
  }, 0);
}

export function getDiscountAmount(cart) {
  return cart.reduce((total, item) => {
    const originalPrice =
      getItemOriginalPrice(item);

    const finalPrice =
      getItemFinalPrice(item);

    const discountPerItem = Math.max(
      originalPrice - finalPrice,
      0
    );

    return (
      total +
      discountPerItem * item.qty
    );
  }, 0);
}

export function getFinalPrice(cart) {
  return getTotalPrice(cart);
}

export const getCartCount = (cart) => {
  return cart.reduce(
    (sum, item) =>
      sum + Number(item.qty || 0),
    0
  );
};